import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { ApiError } from './lib/api';
import { ReleaseWatcher } from './lib/release';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Financial figures should be current, but refetching on every window
      // focus is noisy on a phone that switches apps constantly.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry a request the server deliberately rejected — a 404 on a
        // foreign tenant or a 403 will not become a 200.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
        <ReleaseWatcher />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
